import { createSlice } from "@reduxjs/toolkit";
import { getAllCategories } from "./thunk"; 

const initialState = {
  Categories: [],
  loading: false,
  error: null,
};

const CategoriesSlice = createSlice({
  name: "CategoriesSlice",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.Categories = action.payload; 
      })
      .addCase(getAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default CategoriesSlice.reducer;
